import { Container } from "../components/Container/Container";
import { useTranslation } from "react-i18next";
import { formatDateFr } from "../utils/Date";
// import { useConcerts } from "../hooks/useConcert";
import { FadeInOnScroll } from "../components/FadeInOnScoll/FadeInOnScroll";
import livesData from "../data/lives.json";

export const Live = () => {
  const { t } = useTranslation();

  // const concerts = useConcerts();
  // Filtrer les concerts pour ne garder que ceux à venir
  const concerts = livesData.filter((concert) => {
    // Convertir la date du concert en objet Date
    const [year, month, day] = concert.date.split("/").map(Number);
    const concertDate = new Date(year, month - 1, day);
    // Comparer avec la date actuelle
    return concertDate >= new Date();
  });

  if (!concerts || concerts.length === 0) {
    return null;
  }

  return (
    <div id="concerts" className="bg-yellow-2">
      <Container className="text-lg pb-18 pt-16">
        <div className="container mx-auto px-4">
          <FadeInOnScroll>
            <h2 id="live" className="title-page">
              {t("live")}
            </h2>
          </FadeInOnScroll>
          <FadeInOnScroll delay={200}>
            {concerts.map((concert) => (
              <div
                key={concert.id}
                className="flex flex-col md:flex-row md:space-x-4 p-2 border-b"
              >
                <div className="column-live text-center md:text-left space-y-2">
                  <p className="font-bold">{formatDateFr(concert.date)}</p>
                  <p>{concert.event}</p>
                </div>

                <div className="column-live text-center">
                  <p>{concert.city}</p>
                </div>

                <div className="column-live text-right">
                  <a
                    href={concert.url_information}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn-primary text-sm">
                      {t("btn-information")}
                    </button>
                  </a>
                </div>
              </div>
            ))}
          </FadeInOnScroll>
        </div>
      </Container>
    </div>
  );
};
